export const modalUrlName = 'PQ';
